import { service } from '@ember/service';
import { setOwner } from '@ember/application';

export default class WebsocketActivityHandlersActiveConversation {
  @service conversationAccessEvents;
  @service messaging;
  @service messagingNavigation;

  constructor(owner) {
    setOwner(this, owner);
  }

  handleActivity(response) {
    if (this.#isSelfMessagingDisabled(response)) {
      this.conversationAccessEvents.handleViewerMessagingDisabled();
      return;
    }

    const handler = this.messagingNavigation.currentConversationHandler;
    const conversation = handler?.conversation;

    if (!conversation) {
      return;
    }

    handler.reloadFromShow.perform();
  }

  #isSelfMessagingDisabled(response) {
    if (!this.messaging.groupMessagingEnabled) {
      return false;
    }

    const payload = response.payload ?? {};
    const currentUser = this.messaging.currentProfile?.user;
    const enabled = payload.enabled;
    const externalId = payload.external_id ?? payload.externalId;

    return (
      enabled === false &&
      Boolean(currentUser?.externalId) &&
      String(externalId) === String(currentUser.externalId)
    );
  }
}
